module.exports = __webpack_public_path__ + "img/logo_small.dd1ed1a0.png";